import moment from "moment";

const CATS = {
  possessionPercentage: "Possession",
  totalScoringAtt: "Total Shots",
  ontargetScoringAtt: "On Target",
  bigChanceCreated: "Clear Cut Chances",
  cornerTaken: "Corners",
  totalOffside: "Offsides",
};

export class FFStats {
  constructor({ animate, preview, update, animateOff }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.name = "FFStats";
    this.scene = "FF Stats";
    this.data = [];
    this.show_background = false;
    this.background_toggle = true;
  }

  showBackground(show_background) {
    this.show_background = show_background;
    this.preview({ options: this.options });
  }

  preview({ options }) {
    this.options = options;
    this.onAir = false;
    this.data = [];
    this.data.push({
      name: "Show Background",
      value: {
        visible: this.show_background,
      },
    });
    this.data.push({
      name: "Home Score",
      value: {
        text: options.game?.home_scorers?.length || 0,
      },
    });
    this.data.push({
      name: "Away Score",
      value: {
        text: options.game?.away_scorers?.length || 0,
      },
    });

    this.data.push({
      name: "Home Team Code",
      value: { text: options.game?.home_team?.code || "" },
    });

    this.data.push({
      name: "Home Team Name",
      value: { text: options.game?.home_team?.name || "" },
    });

    this.data.push({
      name: "Home Team Short Name",
      value: { text: options.game?.home_team?.short_name || "" },
    });

    this.data.push({
      name: "Home Team Badge",
      value: {
        image: "${user}" + options.game?.home_team?.variables?.badge,
      },
    });

    this.data.push({
      name: "Away Team Badge",
      value: {
        image: "${user}" + options.game?.away_team?.variables?.badge,
      },
    });

    this.data.push({
      name: "Home Team Secondary Badge",
      value: {
        image: "${user}" + options.game?.home_team?.variables?.alt_badge,
      },
    });

    this.data.push({
      name: "Away Team Badge",
      value: {
        image: "${user}" + options.game?.away_team?.variables?.badge,
      },
    });

    this.data.push({
      name: "Away Team Secondary Badge",
      value: {
        image: "${user}" + options.game?.away_team?.variables?.alt_badge,
      },
    });

    this.data.push({
      name: "Home Team Video Badge",
      value: {
        video: "${user}" + options.game?.home_team?.variables?.video_badge,
      },
    });

    this.data.push({
      name: "Away Team Video Badge",
      value: {
        video: "${user}" + options.game?.away_team?.variables?.video_badge,
      },
    });

    this.data.push({
      name: "Away Team Code",
      value: { text: options.game?.away_team?.code || "" },
    });

    this.data.push({
      name: "Away Team Name",
      value: { text: options.game?.away_team?.name || "" },
    });

    this.data.push({
      name: "Away Team Short Name",
      value: { text: options.game?.away_team?.short_name || "" },
    });

    this.data.push({
      name: "Competition",
      value: { text: options.game?.competition?.name || "" },
    });
    this.data.push({
      name: "Competition Colour",
      value: { colour: options.game?.competition?.colour || "" },
    });
    this.data.push({
      name: "Stadium",
      value: {
        text:
          options.game?.stadium?.name || options.game?.stadium?.opta_name || "",
      },
    });
    this.data.push({
      name: "Kick-Off",
      value: {
      text: moment(`${options.game?.date} ${options.game?.time}`, "YYYY-MM-DD HH:mmZ").format("HH:mm")|| "",
      },
    });

    this.data.push({
      name: "Period",
      value: { text: options.half },
    });
    if (options?.game?.opta_ID) {
      this.buildStats({
        team: "Home",
        stats: options?.game?.opta_team_stats?.home,
        xg_stats: options?.game?.opta_xg_team_stats?.home,
      });
      this.buildStats({
        team: "Away",
        stats: options?.game?.opta_team_stats?.away,
        xg_stats: options?.game?.opta_xg_team_stats?.away,
      });
    }
    if (options?.game?.dfb_ID) {
      this.buildSportecStats({
        team: "Home",
        stats: options?.game?.sportec_team_stats?.home,
      });
      this.buildSportecStats({
        team: "Away",
        stats: options?.game?.sportec_team_stats?.away,
      });
    }
    this.sendPreview(this.scene, 500, this.data, "IN");
  }

  buildStats({ team, stats, xg_stats, options }) {
    this.data.push({
      name: team + " " + CATS.possessionPercentage,
      value: {
        text: stats?.find((s) => s.type === "possessionPercentage")?.value || 0,
      },
    });

    this.data.push({
      name: team + " " + CATS.totalScoringAtt,
      value: {
        text: stats?.find((s) => s.type === "totalScoringAtt")?.value || 0,
      },
    });

    this.data.push({
      name: team + " " + CATS.ontargetScoringAtt,
      value: {
        text: stats?.find((s) => s.type === "ontargetScoringAtt")?.value || 0,
      },
    });

    this.data.push({
      name: team + " " + CATS.bigChanceCreated,
      value: {
        text: stats?.find((s) => s.type === "bigChanceCreated")?.value || 0,
      },
    });

    this.data.push({
      name: team + " " + CATS.cornerTaken,
      value: { text: stats?.find((s) => s.type === "cornerTaken")?.value || 0 },
    });

    this.data.push({
      name: team + " " + CATS.totalOffside,
      value: {
        text: stats?.find((s) => s.type === "totalOffside")?.value || 0,
      },
    });

    this.data.push({
      name: team + " " + CATS.totalOffside,
      value: {
        text: stats?.find((s) => s.type === "totalOffside")?.value || 0,
      },
    });

    this.data.push({
      name: team + " Successful Crosses",
      value: {
        text:
          (stats?.find((s) => s.type === "accurateCross")?.value || 0) +
          "/" +
          (stats?.find((s) => s.type === "totalCross")?.value || 0),
      },
    });

    this.data.push({
      name: team + " Successful Dribbles",
      value: {
        text:
          (stats?.find((s) => s.type === "wonContest")?.value || 0) +
          "/" +
          (stats?.find((s) => s.type === "totalContest")?.value || 0),
      },
    });

    this.data.push({
      name: team + " Red Cards",
      value: {
        text: stats?.find((s) => s.type === "totalRedCard")?.value || 0,
      },
    });

    this.data.push({
      name: team + " Yellow Cards",
      value: {
        text: stats?.find((s) => s.type === "totalYellowCard")?.value || 0,
      },
    });

    this.data.push({
      name: team + " Tackles Won",
      value: {
        text: stats?.find((s) => s.type === "wonTackle")?.value || 0,
      },
    });

    this.data.push({
      name: team + " Interceptions",
      value: {
        text: stats?.find((s) => s.type === "interception")?.value || 0,
      },
    });

    this.data.push({
      name: team + " Blocks",
      value: {
        text: stats?.find((s) => s.type === "outfielderBlock")?.value || 0,
      },
    });

    this.data.push({
      name: team + " Clearances",
      value: {
        text: stats?.find((s) => s.type === "totalClearance")?.value || 0,
      },
    });

    this.data.push({
      name: team + " Headed Clearances",
      value: {
        text: stats?.find((s) => s.type === "headClearance")?.value || 0,
      },
    });

    let aerialWon = stats?.find((s) => s.type === "aerialWon")?.value ?? 0;

    let aerialLost = stats?.find((s) => s.type === "aerialLost")?.value ?? 0;
    let aerialDuels = Math.round(
      (aerialWon / (parseInt(aerialWon) + parseInt(aerialLost))) * 100,
    );

    this.data.push({
      name: team + " Aerial Duels Won",
      value: {
        text: aerialDuels,
      },
    });

    this.data.push({
      name: team + " Blocked Crosses",
      value: {
        text: stats?.find((s) => s.type === "blockedCross")?.value || 0,
      },
    });

    this.data.push({
      name: team + " Passing Accuracy",
      value: {
        text: Math.round(
          ((stats?.find((s) => s.type === "accuratePass")?.value || 0) /
            (stats?.find((s) => s.type === "totalPass")?.value || 0)) *
            100,
        ),
      },
    });

    this.data.push({
      name: team + " Attacking 3rd",
      value: {
        text: Math.round(
          ((stats?.find((s) => s.type === "successfulFinalThirdPasses")
            ?.value || 0) /
            (stats?.find((s) => s.type === "totalFinalThirdPasses")?.value ||
              0)) *
            100,
        ),
      },
    });

    this.data.push({
      name: team + " Key Passes",
      value: {
        text: Math.round(
          stats?.find((s) => s.type === "totalAttAssist")?.value || 0,
        ),
      },
    });

    this.data.push({
      name: team + " Fouls Committed",
      value: {
        text: Math.round(
          stats?.find((s) => s.type === "fkFoulLost")?.value || 0,
        ),
      },
    });

    this.data.push({
      name: team + " Fouls Won",
      value: {
        text: Math.round(
          stats?.find((s) => s.type === "fkFoulWon")?.value || 0,
        ),
      },
    });

    this.data.push({
      name: team + " Yellow Cards",
      value: {
        text: Math.round(
          stats?.find((s) => s.type === "totalYellowCard")?.value || 0,
        ),
      },
    });

    this.data.push({
      name: team + " Red Cards",
      value: {
        text: Math.round(
          stats?.find((s) => s.type === "totalRedCard")?.value || 0,
        ),
      },
    });

    this.data.push({
      name: team + " xG",
      value: {
        text: parseFloat(
          xg_stats?.find((s) => s.type === "expectedGoals")?.value || 0,
        )?.toFixed(2),
      },
    });
  }

  buildSportecStats({ team, stats, options }) {
    this.data.push({
      name: team + " " + CATS.possessionPercentage,
      value: {
        text: stats?.find((s) => s.type === "PossessionPercentage")?.value || 0,
      },
    });

    this.data.push({
      name: team + " " + CATS.totalScoringAtt,
      value: {
        text: stats?.find((s) => s.type === "ShotsAtGoalSum")?.value || 0,
      },
    });

    this.data.push({
      name: team + " " + CATS.ontargetScoringAtt,
      value: {
        text: stats?.find((s) => s.type === "ShotsOnTarget")?.value || 0,
      },
    });

    this.data.push({
      name: team + " " + CATS.bigChanceCreated,
      value: {
        text: stats?.find((s) => s.type === "AssistsShotAtGoal")?.value || 0,
      },
    });

    this.data.push({
      name: team + " " + CATS.cornerTaken,
      value: {
        text: stats?.find((s) => s.type === "CornerKicksSum")?.value || 0,
      },
    });

    this.data.push({
      name: team + " " + CATS.totalOffside,
      value: {
        text: stats?.find((s) => s.type === "Offsides")?.value || 0,
      },
    });

    this.data.push({
      name: team + " " + CATS.totalOffside,
      value: {
        text: stats?.find((s) => s.type === "Offsides")?.value || 0,
      },
    });

    this.data.push({
      name: team + " Successful Crosses",
      value: {
        text:
          (stats?.find((s) => s.type === "CrossesSuccessfulSum")?.value || 0) +
          "/" +
          (stats?.find((s) => s.type === "CrossesSum")?.value || 0),
      },
    });

    this.data.push({
      name: team + " Successful Dribbles",
      value: {
        text:
          (stats?.find((s) => s.type === "DribblingsSuccessful")?.value || 0) +
          "/" +
          (stats?.find((s) => s.type === "DribblingsSuccessful")?.value || 0),
      },
    });

    this.data.push({
      name: team + " Red Cards",
      value: {
        text: stats?.find((s) => s.type === "CardsRed")?.value || 0,
      },
    });

    this.data.push({
      name: team + " Yellow Cards",
      value: {
        text:
          parseInt(
            stats?.find((stat) => stat.type === "CardsYellow")?.value ?? 0,
          ) +
          parseInt(
            stats?.find((stat) => stat.type === "CardsYellowRed")
              ?.value ?? 0,
          ),
      },
    });

    this.data.push({
      name: team + " xG",
      value: {
        text: parseFloat(
          stats?.find((s) => s.type  === "xG")?.value || 0,
        )?.toFixed(2),
      },
    });

    this.data.push({
      name: team + " Tackles",
      value: {
        text: stats?.find((s) => s.type === "TacklingGamesSum")?.value || 0,
      },
    });

    this.data.push({
      name: team + " Tackles Won",
      value: {
        text: stats?.find((s) => s.type === "TacklingGamesWon")?.value || 0,
      },
    });

    this.data.push({
      name: team + " Interceptions",
      value: {
        text: stats?.find((s) => s.type === "InterceptionsSum")?.value || 0,
      },
    });

    this.data.push({
      name: team + " Blocks",
      value: {
        text: stats?.find((s) => s.type === "ShotsAtGoalBlocked")?.value || 0,
      },
    });

    this.data.push({
      name: team + " Clearances",
      value: {
        text: stats?.find((s) => s.type === "DefensiveClearances")?.value || 0,
      },
    });

    let aerialpercentage =
      (parseInt(
        stats?.find((s) => s.type === "TacklingGamesAirWon")?.value || 0,
      ) /
        parseInt(
          stats?.find((s) => s.type === "TacklingGamesAirSum")?.value || 0,
        )) *
      100;
      

    this.data.push({
      name: team + " Aerial Duels Won",
      value: {
        text: Math.round(aerialpercentage),
      },
      });

    this.data.push({
      name: team + " Passing Accuracy",
      value: {
        text: (Math.round(
          ((parseInt(stats?.find((s) => s.type === "PassesSuccessfulSum")?.value) || 0) /
            parseInt(stats?.find((s) => s.type === "PassesSum")?.value) || 0) *
            100,
        )).toString(),
      },
    });

    this.data.push({
      name: team + " Attacking 3rd",
      value: {
        text: (Math.round(stats?.find((s) => s.type === "PassesFromOpenPlayOffensiveThirdSuccessfulRatio",
        )?.value || 0,)).toString(),
      },
    });

    this.data.push({
      name: team + " Key Passes",
      value: {
        text: Math.round(
          stats?.find((s) => s.type === "AssistsShotAtGoal")?.value || 0,
        ),
      },
    });

        this.data.push({
      name: team + " Blocked Crosses",
      value: {
        text: stats?.find((s) => s.type === "InterceptionsCorner")?.value || 0,
      },
    });

    this.data.push({
      name: team + " Total Passes",
      value: {
        text: Math.round(
          stats?.find((s) => s.type === "PassesSum")?.value || 0,
        ),
      },
    });

    this.data.push({
      name: team + " Chances",
      value: {
        text: Math.round(stats?.find((s) => s.type === "Chances")?.value || 0),
      },
    });

    this.data.push({
      name: team + " Freekicks",
      value: {
        text: Math.round(stats?.find((s) => s.type === "FreeKicksSum")?.value || 0),
      },
    });


    
    this.data.push({
      name: team + " Fouls Committed",
      value: {
        text: Math.round(stats?.find((s) => s.type === "FoulsSum")?.value || 0),
      },
    });

    this.data.push({
      name: team + " Fouls Won",
      value: {
        text: Math.round(stats?.find((s) => s.type === "FoulsSuffered")?.value || 0),
      },
    });
  }

  

  animate({ options }) {
    this.onAir = true;

    this.sendAnimate(this.scene, this.data);
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff(this.scene, []);
  }
}
